import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "void_items";
const addVoidItem = (voidItem) => axios.post(baseURL, voidItem);

export {
    addVoidItem
}